const BLACK_ACTION_TYPES = {
  LOAD_BLACK: 'black/LOAD_BLACK',
};

export default BLACK_ACTION_TYPES;
